import { Inject, Injectable } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { OnAppInit } from '@frontend/vanilla/core';

import { ON_LCG_APP_INIT } from './run-on-init.provider';

@Injectable({ providedIn: 'root' })
export class LazyBootstrapService {
    private isAlreadyBootstrapped = false;

    constructor(@Inject(ON_LCG_APP_INIT) private initializers: OnAppInit[]) {}

    async onLCGAppInit(): Promise<any> {
        if (this.isAlreadyBootstrapped) {
            return;
        }

        const promises: Promise<any>[] = [];

        for (const initializer of this.initializers) {
            const promise = initializer.onAppInit();

            if (!(promise instanceof Promise)) {
                continue;
            }

            promises.push(promise);
        }

        await Promise.all(promises);

        this.isAlreadyBootstrapped = true;
    }
}
